<template>
  <header class="app-header">
    <div class="header-content">
      <div class="logo-section">
        <img src="@/assets/logo.png" alt="Chrilan Technology Subscription Logo" class="logo" />
      </div>
      <div class="brand-section">
        <h1 class="brand-title">Chrilan Technology Subscription</h1>
        <p class="brand-subtitle">
          Powered by <a href="https://chrilantech.com" target="_blank" rel="noopener">Chrilan Technology</a>
        </p>
        <p class="brand-tagline">{{ tagline }}</p>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'AppHeader',
  props: {
    tagline: {
      type: String,
      default: 'Empowering your business, one transaction at a time.'
    }
  }
}
</script>

<style scoped>
.app-header {
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 0.75rem;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
}

.header-content {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.logo-section {
  flex-shrink: 0;
}

.logo {
  height: 80px;
  width: auto;
  object-fit: contain;
}

.brand-section {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.brand-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #0ea5e9;
  margin: 0;
  line-height: 1.2;
}

.brand-subtitle {
  font-size: 1rem;
  color: #52525b;
  margin: 0;
}

.brand-subtitle a {
  color: #0ea5e9;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s;
}

.brand-subtitle a:hover {
  color: #0284c7;
  text-decoration: underline;
}

.brand-tagline {
  font-size: 0.875rem;
  color: #a1a1aa;
  margin: 0;
}

@media (max-width: 576px) {
  .header-content {
    flex-direction: column;
    text-align: center;
  }

  .logo {
    height: 60px;
  }

  .brand-title {
    font-size: 1.25rem;
  }
}
</style>
